import React from 'react';
import { SkeletonLine } from '@wix/wix-ui-tpa/cssVars';
import classes from './PlanStartDatePickerLoader.css';

export const PlanStartDatePickerLoader = () => (
  <div className={classes.root}>
    <SkeletonLine className={classes.label} />
    <SkeletonLine className={classes.input} />
  </div>
);
